<div class="footer d-flex align-items-center justify-content-between px-5">
  <img src="/assets/images/logo.svg" alt="logo: dollars and decisions" />
  <div class="d-flex flex-column align-items-end">
    <span class="fs-7">Copyright © 2023. All rights reserved.</span>
    <span class="fs-7"
      >101 JFK Parkway | Short Hills, NJ | 07078 | (973) 921-5500</span
    >
  </div>
</div>
